import React from 'react'

const Footer = () => (
  <footer className="footer has-text-centered has-text-white has-background-dark">
    <h1 className="subtitle has-text-white">API from PotterAPI, made by Aino and Alex @ GA</h1>
  </footer>
)

export default Footer